import { request } from './index';
import { Loadable } from 'recoil';
import { RawPersonalInfo, RawScenarioBasicInfo, RawScenarioPageInfo } from '../types/rawScenario';

interface SetQuestionAnswerParam {
  token: string;
  questionId: number;
  scenarioBasicInfo: RawScenarioBasicInfo;
  scenarioPageInfo: RawScenarioPageInfo[];
  personalInfo: RawPersonalInfo | null;
}
interface SetQuestionAnswerResult {
  result: string;
  message: string;
}
export const setQuestionAnswer = (param: SetQuestionAnswerParam): Loadable<SetQuestionAnswerResult> => {
  return request('SetQuestionAnswer', {
    ...param,
    scenarioBasicInfo: JSON.stringify(param.scenarioBasicInfo),
    scenarioPageInfo: JSON.stringify(param.scenarioPageInfo),
  });
}
